import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Calendar, User, ArrowLeft, Facebook, Twitter, Linkedin } from 'lucide-react';
import api, { enrichBlog } from '../lib/api';

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    api.get('/blog/' + slug).then(r => setPost(enrichBlog(r.data)));
    api.get('/blog').then(r => setRelated((r.data || []).map(enrichBlog).filter(p => p.slug !== slug).slice(0, 3)));
  }, [slug]);

  if (!post) return <div className="min-h-screen flex items-center justify-center text-neutral-500">Loading...</div>;

  return (
    <div className="bg-white">
      <div className="relative h-[420px] overflow-hidden">
        <img src={post.cover} alt={post.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/80" />
        <div className="relative max-w-4xl mx-auto px-6 h-full flex flex-col justify-end pb-10 text-white">
          <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-neutral-200 hover:text-white mb-3"><ArrowLeft className="w-4 h-4" /> Back to blog</Link>
          <span className="inline-block px-3 py-1 bg-[#DC2626] text-xs font-semibold uppercase tracking-wider rounded w-fit">{post.category}</span>
          <h1 className="text-3xl md:text-5xl font-bold mt-3">{post.title}</h1>
          <div className="mt-4 flex items-center gap-5 text-sm text-neutral-300">
            <span className="flex items-center gap-1"><User className="w-4 h-4" /> {post.author}</span>
            <span className="flex items-center gap-1"><Calendar className="w-4 h-4" /> {post.date}</span>
          </div>
        </div>
      </div>

      <article className="max-w-3xl mx-auto px-6 py-12">
        <p className="text-lg text-neutral-700 leading-relaxed font-medium mb-6">{post.excerpt}</p>
        <div className="text-neutral-800 leading-relaxed whitespace-pre-line">{post.content}</div>

        <div className="mt-10 pt-6 border-t border-neutral-200 flex items-center justify-between">
          <p className="text-sm text-neutral-500">Share this article</p>
          <div className="flex gap-2">
            <a href="#" className="w-9 h-9 rounded-full bg-neutral-100 hover:bg-[#DC2626] hover:text-white flex items-center justify-center"><Facebook className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full bg-neutral-100 hover:bg-[#DC2626] hover:text-white flex items-center justify-center"><Twitter className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full bg-neutral-100 hover:bg-[#DC2626] hover:text-white flex items-center justify-center"><Linkedin className="w-4 h-4" /></a>
          </div>
        </div>
      </article>

      {related.length > 0 && (
        <section className="bg-neutral-50 py-12">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-2xl font-bold text-neutral-900 mb-6">Related Articles</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {related.map((p) => (
                <Link to={'/blog/' + p.slug} key={p.id} className="block card-hover bg-white border border-neutral-200 rounded-xl overflow-hidden">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={p.cover} alt={p.title} className="w-full h-full object-cover" />
                  </div>
                  <div className="p-5">
                    <span className="text-xs font-semibold uppercase tracking-wider text-[#DC2626]">{p.category}</span>
                    <h3 className="mt-2 font-bold text-neutral-900 line-clamp-2">{p.title}</h3>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
